import React from 'react';
import trans from 'translate';
import './HordButtons.scss';

const HordButtons = () => (
  <div className="hord-header-buttons">
    {/*
    <a href="https://dcentralab.typeform.com/to/Jp5jmOcy" target="_blank" rel="noopener noreferrer" type="button" className="button medium applyAsChampion">
      {trans('header.apply_as_champion')}
    </a>
    */}
    <a
      href="https://opensea.io/collection/hord-app-pool-tickets"
      target="_blank"
      rel="noopener noreferrer"
      type="button"
      className="button medium openSea"
    >
      {trans('header.open_sea')}
    </a>
  </div>
);

export default HordButtons;
